//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import { allowAccessibilityColors } from "@/assets/js/appFunc";
import { mapState } from "vuex";

export default {
    name: "SetAccessibility",
    components: {
        AQToggle
    },
    props: {
        closeAccessibility: { type: Boolean, default: false }
    },
    data() {
        return {
            isAccessibilityClosed: true,
            toggleContrastValue: false
        };
    },
    computed: {
        ...mapState("components", ["isSmallScreen"])
    },
    watch: {
        closeAccessibility(newVal) {
            if (newVal) {
                this.isAccessibilityClosed = true;
                this.$emit("changeAccessibility", false);
            }
        }
    },
    mounted() {
        this.saveAccessibility();
    },
    activated() {
        this.saveAccessibility();
    },
    methods: {
        showAccessibility() {
            this.isAccessibilityClosed = !this.isAccessibilityClosed;
        },
        changeAccessibility() {
            localStorage.setItem("accessibility", this.toggleContrastValue);
            localStorage.setItem("changedAccessibility", true);
            allowAccessibilityColors(this.toggleContrastValue);
        },
        saveAccessibility() {
            this.isAccessibilityClosed = true;
            const allowAccessibility = localStorage.getItem("accessibility");
            this.toggleContrastValue = allowAccessibility === "true";
        }
    }

};
